/* tslint:disable */
/* eslint-disable */
// this is a manually created file by Adam
import * as APITypes from "../API";

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getTemplateShallow =
  /* GraphQL */ `query GetTemplateShallow($id: ID!) {
    getTemplate(id: $id) {
      id
      name
      owners
      createdAt
      sectionOrder
      advanced
      updatedAt
      _version
      _lastChangedAt
      _deleted
      sections {
        items {
          name
          _deleted
          _lastChangedAt
          _version
          createdAt
          id
          isSimple
          textboxes {
            items {
              id
              value
              _version
              createdAt
              _deleted
              _lastChangedAt
            }
          }
          owners
          updatedAt
          subsectionOrder
          subsections {
            items {
              _version
              owners
              createdAt
              _deleted
              _lastChangedAt
              fieldOrder
              id
              name
              sID
              fields {
                items {
                  _deleted
                  _lastChangedAt
                  createdAt
                  _version
                  id
                  name
                  owners
                  updatedAt
                  value
                }
              }
            }
          }
        }
      }
    }
  }
  ` as GeneratedQuery<
    APITypes.GetTemplateQueryVariables,
    APITypes.GetTemplateQuery
  >;
